var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-container',[_c('exhibition-view')],1),_c('v-container',[_c('exhibition-form')],1),(_vm.approvedBooths && _vm.approvedBooths.length > 0)?_c('v-container',[_c('exhibition-logos')],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }